<template>
  <div>
    <div class="sub_visual_wrap">
        <div class="sub_visual_box container">
            <div class="page_nav">
                <ul>
                    <li><a href="#">Home</a></li>
                    <li><a href="#">Search Results</a></li>
                </ul>
            </div>
            <h2>Search Results</h2>
        </div>
    </div>

	<router-view></router-view>    

  </div>
</template>

<script>
export default {
}
</script>

<style>

</style>